import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 19,
	viewBox: "0 0 21 19",
	width: 21,
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#6D6D6D",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m19.8235 2.98242h-11.45777" }),
			/* @__PURE__ */ _jsx("path", { d: "m4.27366 2.98242h-3.27366" }),
			/* @__PURE__ */ _jsx("path", { d: "m19.8235 9.53125h-3.2736" }),
			/* @__PURE__ */ _jsx("path", { d: "m12.5843 9.53125h-11.5843" }),
			/* @__PURE__ */ _jsx("path", { d: "m19.8235 16.0781h-11.44566" }),
			/* @__PURE__ */ _jsx("path", { d: "m4.28576 16.0781h-3.28576" }),
			/* @__PURE__ */ _jsx("path", { d: "m8.31458 1h-3.96555v3.96555h3.96555z" }),
			/* @__PURE__ */ _jsx("path", { d: "m16.5499 7.54688h-3.9656v3.96552h3.9656z" }),
			/* @__PURE__ */ _jsx("path", { d: "m8.25132 14.0957h-3.96555v3.9656h3.96555z" })
		]
	})
});
export default SvgFilter;
